// extracted by mini-css-extract-plugin
module.exports = {"spinner":"VideoWrapper-module__spinner___31Wh3","video":"VideoWrapper-module__video___TRS0E"};